import Cookies from 'js-cookie';

export class CookieService {
  static instance: CookieService | null = null;

  static getInstance(): CookieService {
    if (!CookieService.instance) {
      CookieService.instance = new CookieService();
    }
    return CookieService.instance;
  }

  getToken(): string {
    const token = Cookies.get('token') || '';
    return token;
  }
  removeToken() {
    Cookies.remove('token');
  }
  setToken(token: string, options: Cookies.CookieAttributes | undefined) {
    Cookies.set('token', token, options);
  }

  getId(): string {
    const id = Cookies.get('id') || '';
    return id;
  }
  removeId() {
    Cookies.remove('id');
  }
  setId(id: string, options: Cookies.CookieAttributes | undefined) {
    Cookies.set('id', id, options);
  }
}
